import React, { FC } from "react";
import { faChevronDown } from "@fortawesome/pro-regular-svg-icons/faChevronDown";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const ChevronDown: FC<JSX.IntrinsicAttributes> = (props) => (
  <FontAwesomeIcon icon={faChevronDown} {...props} />
);
